import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=443bc4ec&"
import script from "./Tech.vue?vue&type=script&lang=js&"
export * from "./Tech.vue?vue&type=script&lang=js&"
import style0 from "./Tech.vue?vue&type=style&index=0&id=443bc4ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VContainer,VFlex,VImg,VLayout})
